import apiHandler from "middlewares/apiHandler";
import { CapexQueryModel } from "../../pages/PortfolioView/Data/CapexPlan";

export const _getCapexPlanData = async (capexQueryModels: CapexQueryModel[]) => {
    return apiHandler.post<any>("portfolio/capexplandata", capexQueryModels);
};